export const environment = {
  production: false,
  appName: 'Sense Underwriting',
  apimUrl: 'https://bp-dev-apim.azure-api.net/suw-dev',
  apiPrefix: 'api',
  version: 'v1',
  app_id: 'suw-dev',
  clarityProjectId: 'xuvkh0e2sw',
  platformUrl: 'https://bp-dev-apim.azure-api.net/pf-dev/',
  platformSupportUrl: 'https://bp-dev-apim.azure-api.net/pf-dev-lib/',
  pingMapsUrl: "https://app.pingintel.com/maps/",
  federatoUrl: "https://velocity-uat.federato.ai/uw-portal/",
  isBPAllSubmissionEnabledForAll: true,
  chatApiBaseUrl: 'https://bp-dev-apim.azure-api.net/chat-component',
  socketBaseUrl: 'https://bp-dev-apim.azure-api.net/chat-engine',
  indexedDbCacheExpiryMinutes: 360,
  dashboardUrl: 'https://bp-dev-apim.azure-api.net/dashboard-dev/',
  newPricingQuotingEnable:true,
  docSearchForChatInputEnbled: true,
};
